<template>
    <Page>
        <Container>
            <div class="mx-auto max-w-md py-12">
                <div class="text-center mb-8">
                    <h1 class="text-3xl font-bold mb-4 text-neutral-900 dark:text-white">Thank You!</h1>
                    <p class="text-lg text-neutral-700 dark:text-neutral-400 mb-6">
                        We're thrilled to hear you're enjoying V3ME! Your feedback means the world to us.
                    </p>
                    <p class="text-base text-neutral-600 dark:text-neutral-500 mb-8">
                        Would you mind leaving us a review on TrustPilot?
                    </p>
                </div>
                
                <div class="flex items-center justify-center">
                  <TrustPilotStars />
                </div>
            </div>
        </Container>
    </Page>
</template>

<script>
import {defineComponent} from 'vue'
import TrustPilotStars from '@/components/TrustPilotStars.vue'

export default defineComponent({
  name: 'Review',
  components: {
    TrustPilotStars,
  },
})
</script>

<style scoped lang="scss">

</style>
